export type WorkExperienceDates = {
  is_current?: boolean;
  isCurrent?: boolean;
  startDate?: string;
  endDate?: string;
};

/** True when the job is marked current or has a start date and no end date. */
export function isOpenEndedJob(exp: WorkExperienceDates): boolean {
  if (exp.is_current || exp.isCurrent) return true;
  return !!(exp.startDate || '').trim() && !(exp.endDate || '').trim();
}

export function workExperienceEndDateRequired(isCurrent: boolean): boolean {
  return !isCurrent;
}

export function applyCurrentJobToggle<T extends WorkExperienceDates>(exp: T, isCurrent: boolean): T {
  return {
    ...exp,
    is_current: isCurrent,
    endDate: isCurrent ? '' : exp.endDate,
  };
}

export function hydrateWorkExperienceItem<T extends WorkExperienceDates>(exp: T): T & { is_current: boolean; startDate: string; endDate: string } {
  const is_current = isOpenEndedJob(exp);
  return {
    ...exp,
    startDate: exp.startDate || '',
    endDate: is_current ? '' : (exp.endDate || ''),
    is_current,
  };
}

export function persistWorkExperienceItem<T extends WorkExperienceDates>(exp: T): T & { is_current: boolean; endDate: string } {
  return {
    ...exp,
    is_current: !!exp.is_current,
    endDate: exp.is_current ? '' : (exp.endDate || ''),
  };
}
